module.exports = __webpack_public_path__ + "media/02.bd253ea2.mp3";